import React, { Component } from "react";

export default class SearchButton extends Component {
  render() {
    return (
      <div className="col-md-3">
        <div className="col-md-10 margin-top-20">
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.props.onSearch}
          >
            Search
          </button>
        </div>
      </div>
    );
  }
}
